import React, { useContext } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { useDeviationViewContext } from '../../../../Context';
import { SecondaryActionBarContext } from '../../../ActionBarContext';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribersOnly from '../../../_partials/SubscribersOnly';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import DeviationFlags from '../../../buttons/DeviationFlags';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import BuyButton from '../../../buttons/BuyButton';
import EditButton from '../../../buttons/EditButton';
import EditBackgroundButton from '../../../buttons/EditBackgroundButton';
import DeleteButton from '../../../buttons/DeleteButton';
import ExpandButton from '../../../buttons/ExpandButton';
import AwardBadgeButton from '../../../buttons/AwardBadgeButton';
import FreeDownloadButton from '../../../buttons/DownloadButton/FreeDownloadButton';
import PremiumDownloadButton from '../../../buttons/DownloadButton/PremiumDownloadButton';
import DownloadWithCommentPrompt from '../../../buttons/DownloadButton/DownloadButtonWithCommentPrompt';
import SellYourArtLink from '../../../buttons/SellYourArtLink';
import DasButton from '../../../../Das/Button';
import FluidMargin from '../FluidMargin';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export const PrimaryDesktopActionBar = ({ deviation , isOwner , className , expandAndFocusCommentPanel  })=>{
    const { adsEnabled  } = useContext(SessionContext);
    const { isTheater  } = useDeviationViewContext();
    const { setTopActionBarRef  } = useContext(SecondaryActionBarContext);
    const { hasFlag , hasMoreActions , isCommentable , isDownloadable , isEditable , isDeletable , isFavouritable , isGroupSubmittable , isPrintPurchasable , isPurchasable , canHavePremiumDownload , isReportable , isBackgroundEditable , isCoreBadgeAwardable , isAssetPurchasable  } = useDeviationAttributes(deviation, isOwner);
    const { tier  } = useSubscriptionTier(deviation);
    const isTextual = isTextualDeviation(deviation);
    const hasSubsBadge = !hasFlag && !!tier;
    const badgeClassnames = classnames(desktopActionBarStyles['badge'], hasSubsBadge && desktopActionBarStyles['subs-badge']);
    const isShowingBuyButton = isPrintPurchasable && false;
    const showSellYourArt = isOwner && canHavePremiumDownload && !isPurchasable && !deviation.isDreamsofart;
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        ref: setTopActionBarRef,
        className: classnames(desktopActionBarStyles['root'], isTheater ? desktopActionBarStyles['theater'] : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: badgeClassnames
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        className: desktopActionBarStyles['flag'],
        deviation: deviation,
        disableLabel: isTextual
    }), hasSubsBadge && /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation,
        className: desktopActionBarStyles['subscribers-only'],
        textClassName: desktopActionBarStyles['subscribers-only-text']
    })), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 1
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-middle']
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isFavouritable && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), isCommentable && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner,
        actionBarType: "primary"
    }))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 4
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isGroupSubmittable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), isCoreBadgeAwardable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), isPurchasable && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: desktopActionBarStyles['icon'],
        buttonComponent: PremiumDownloadButton,
        deviation: deviation
    }), isDownloadable && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: desktopActionBarStyles['icon'],
        buttonComponent: FreeDownloadButton,
        deviation: deviation
    })), (isShowingBuyButton || isReportable || isEditable || isDeletable || isAssetPurchasable) && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 2
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isShowingBuyButton && !isAssetPurchasable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(BuyButton, {
        deviation: deviation
    })), isAssetPurchasable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(DasButton, {
        deviation: deviation
    })), showSellYourArt && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), isBackgroundEditable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditBackgroundButton, {
        deviation: deviation
    })), isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 3
    }), !adsEnabled && /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    }, /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    }))), adsEnabled && /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            maxWidth: '112px'
        }
    }))));
};
PrimaryDesktopActionBar.displayName = 'PrimaryDesktopActionBar';
export default PrimaryDesktopActionBar;
